import ReassignHistoryDialog from "./reassign-history.container";

export default ReassignHistoryDialog;
